/**
 * Default throttle interval (ms) for SignalR-driven list refreshes when
 * `environment.realtimeRefreshThrottleMs` is not explicitly set.
 * Single source of truth — keep in sync with documentation in app-config.ts.
 */
export const DEFAULT_REALTIME_REFRESH_THROTTLE_MS = 2000;
